import { render } from "./FileDocument.vue?vue&type=template&id=ca10429a"
import script from "./FileDocument.vue?vue&type=script&lang=js"
export * from "./FileDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FileDocument.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca10429a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca10429a', __exports__)) {
    api.reload('ca10429a', __exports__)
  }
  
  module.hot.accept("./FileDocument.vue?vue&type=template&id=ca10429a", () => {
    api.rerender('ca10429a', render)
  })

}


export default __exports__